export default __webpack_public_path__ + "static/media/edit.a172e3bf.svg";